import { Action, AsyncAction } from "../../../types/actions";
import { GetEvents } from "../../../connection/events";
import { BrandliveEvent } from "../../../types/working-model";

export const GET_EVENTS = "GET_EVENTS";
export function getEvents(channel: number, token: string): AsyncAction {
	return {
		type: GET_EVENTS,
		promise: GetEvents(channel, token)
	};
}

export const ADD_ADMIN_EVENT = "ADD_ADMIN_EVENT";
export function addAdminEvent(event: BrandliveEvent): Action {
	return {
		type: ADD_ADMIN_EVENT,
		payload: event
	};
}

export const UPDATE_ADMIN_EVENT = "UPDATE_ADMIN_EVENT";
export function updateAdminEvents(event: BrandliveEvent): Action {
	return {
		type: UPDATE_ADMIN_EVENT,
		payload: event
	};
}


export const UPDATE_EVENTS_NAME = "UPDATE_EVENTS_NAME";
export function updateEventsName(event: BrandliveEvent): Action {
	return {
		type: UPDATE_EVENTS_NAME,
		payload: event
	};
}

export const CLEAR_EVENTS = "CLEAR_EVENTS";
export function clearEvents(): Action {
	return {
		type: CLEAR_EVENTS,
		payload: null
	};
}

export const REMOVE_SESSION_FROM_EVENT = 'REMOVE_SESSION_FROM_EVENT';
export function removeSessionFromEventsReducer(sessionID: number, eventUuid: string): Action {
	return {
		type: REMOVE_SESSION_FROM_EVENT,
		payload: { sessionID, eventUuid },
	};
}

export const REMOVE_EVENT_FROM_EVENTS = 'REMOVE_EVENT_FROM_EVENTS';
export function removeEventFromEventsReducer(eventUuid: string): Action {
	return {
		type: REMOVE_EVENT_FROM_EVENTS,
		payload: eventUuid,
	};
}
